import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../createApiConfig';

export const CustomerApi = createApi({
  reducerPath: 'CustomerApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Customer'],
  endpoints: (builder) => ({
    listUsers: builder.query({
      query: (params) => ({
        url: `/customers/`,
        params,
      }),
      providesTags: ['Customer'],
    }),

    createCustomer: builder.mutation({
      query: (data) => ({
        url: `/customers/?expand=user,last_updated_by,country`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Customer'],
    }),

    updateCustomer: builder.mutation({
      query: ({ id, data }) => ({
        url: `/customers/${id}/?expand=user,last_updated_by,country`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Customer'],
    }),


    listCustomerPlatforms: builder.query({
      query: (params) => ({
        url: `/campaigns/platforms/bulk/`,
        params,
      }),
      providesTags: ['Customer'],
    }),

    bulkCreatePlatforms: builder.mutation({
      query: (data) => ({
        url: `/campaigns/platforms/bulk/`,
        method: 'POST',
        body: data,
      }),
      
      invalidatesTags: ['Customer'],
    }),
  }),
});

export const {
  useListUsersQuery,
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
  useListCustomerPlatformsQuery,
  useBulkCreatePlatformsMutation,
} = CustomerApi;
